/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
type Theme = {
  initialColorMode: 'light' | 'dark';
  primaryColor: string;
  bgColor: string;
  hoverBgColor: string;
  keyboardFocusBgColor: string;
  chipBorder: string;
  chipIconColor: string;
  textDefaultColor: string;
  textDisabledColor: string;
  inputDefaultColor: string;
  inputFocusedColor: string;
  inputReadOnlyColor: string;
  titleColor: string;
  delimiterColor: string;
  delimiterColorLight: string;
};

// We are not using the light theme for now, but we may want to add it back in the future
// const lightTheme: Theme = {
//   initialColorMode: 'light',
//   primaryColor: 'var(--color-aurora-blue)',
//   bgColor: 'var(--color-milky-way)',
//   hoverBgColor: 'var(--color-gray-1)',
//   keyboardFocusBgColor: 'var(--color-gray-2)',
//   chipBorder: 'var(--color-blast-off-blue)',
//   chipIconColor: 'var(--color-galaxy-gray)',
//   inputDefaultColor: 'var(--color-gravity-gray)',
//   inputFocusedColor: 'var(--color-blast-off-blue)',
//   inputReadOnlyColor: 'var(--color-galaxy-gray)',
//   textDefaultColor: 'var(--color-black-hole)',
//   textDisabledColor: 'var(--color-gravity-gray)',
//   titleColor: 'var(--color-galaxy-gray)',
//   delimiterColor: 'var(--color-gravity-gray)',
//   delimiterColorLight: 'var(--color-crater-gray)',
// };

const darkTheme: Theme = {
  initialColorMode: 'dark',
  primaryColor: 'var(--color-blast-off-blue)',
  bgColor: 'var(--color-old-background)',
  hoverBgColor: 'var(--color-gray-8)',
  keyboardFocusBgColor: 'var(--color-gray-9)',
  chipBorder: 'var(--color-gray-7)',
  chipIconColor: 'var(--color-gravity-gray)',
  inputDefaultColor: 'var(--color-gravity-gray)',
  inputFocusedColor: 'var(--color-blast-off-blue)',
  inputReadOnlyColor: 'var(--color-galaxy-gray)',
  textDefaultColor: 'var(--color-milky-way)',
  textDisabledColor: 'var(--color-gray-5)',
  titleColor: 'var(--color-gray-5)',
  delimiterColor: 'var(--color-gravity-gray)',
  delimiterColorLight: 'var(--color-gray-5)',
};

export { darkTheme };
